module.exports = "/public/assets/img/panoramaMono.svg";